function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "evenodd",
  d: "M4,18 L10,18 L10,16 L4,16 L4,18 Z M4,6 L4,8 L20,8 L20,6 L4,6 Z M4,13 L15,13 L15,11 L4,11 L4,13 Z"
});
function SvgSortMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortMenu);
export default __webpack_public_path__ + "static/media/sort-menu.c990dd842866b0e83389757acad0c425.svg";
export { ForwardRef as ReactComponent };